import {
  SSN_REGEX,
  DATE_REGEX,
  EMAIL_REGEX,
  PASSWORD_REGEX,
  PHONE_REGEX,
  validFileTypes,
} from '../constants';

export const validateEmail = (email = '', field) => {
  const isValid = EMAIL_REGEX.test(email?.toString()?.trim()?.toLowerCase());
  if (!isValid) throw new Error('Provide a valid email address');
};

export const validatePassword = (password) => {
  const isValid = PASSWORD_REGEX.test(String(password).trim());
  if (!isValid) throw new Error('Password must contain 8 characters');
};

export const validateSSN = (SSN) => {
  const isValid = SSN_REGEX.test(String(SSN.toString()).trim().toLowerCase());
  if (!isValid) throw new Error('Provide a valid social security number');
};

export const validatePhone = (num) => {
  const isValid = PHONE_REGEX.test(String(num.toString()).trim().toLowerCase());
  if (!isValid) throw new Error('Please provide a valid phone number');
};

export const validateDate = (dateString) => {
  const isValid = DATE_REGEX.test(String(dateString).trim().toLowerCase());
  if (!isValid) throw new Error('Please enter a valid date');
};

export const validateLength = (value, field, min = 1, max = 200) => {
  if (!value) throw new Error(`Field is required`);
  const string = value?.toString()?.trim();
  const isValid = string.length >= min && string.length <= max;
  if (!isValid)
    throw new Error(
      `Must be greater than ${min} characters and lower than ${max}`
    );
};

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const fileMimeTypes = validFileTypes.map((file) => file.mimeType);
export const fileExtensions = validFileTypes.map((file) => file.extension);
